import React from 'react';

import { connect } from 'react-redux';


import { v4 as uuid } from "uuid";

import { resolve, mapStateToProps } from "../smart/delegator/DataDelegator";
import Page from '../smart/Page';

class SuccessModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            instanceIdentifier: uuid(),
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show) {
            if (this.props.show === true) {
                $(`#modal-success-${this.state.instanceIdentifier}`).modal({ backdrop: 'static', keyboard: false });
            } else {
                $(`#modal-success-${this.state.instanceIdentifier}`).modal('hide');
            }
        }
    }

    componentDidMount() {
        resolve(this.props, () => {
            if(this.props.show === true) {
                $(`#modal-success-${this.state.instanceIdentifier}`).modal({ backdrop: 'static', keyboard: false });
            }
        });
    }

    onClose() {
        if (typeof this.props.onClose == "function") {
            this.props.onClose();
        } else if(this.props.onClose !== null && typeof this.props.onClose == "object") {
            if(this.props.onClose.type) {
                switch(this.props.onClose.type) {
                    case "redirect": {
                        if(this.props.onClose.redirect === true && this.props.onClose.redirect_url.length > 0) {
                            window.location = this.props.onClose.redirect_url;
                        }
                        break;
                    }

                    default: {
                        console.log(`Unknown onClose type ${this.props.onClose.type}`);
                        break;
                    }
                }
            }
        }

        $(`#modal-success-${this.state.instanceIdentifier}`).modal('hide');
    }

    render() {
        const message = Array.isArray(this.props.message) ? this.props.message : [this.props.message];

        return (
            <div id={`modal-success-${this.state.instanceIdentifier}`} className="modal fade" tabIndex="-1">
                <div className={`modal-dialog ${this.props.modalSize === "large" ? "modal-xl" : ""}`}>
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="text-center">
                                <h1 className="error-code text-success"><i className="fas fa-check fa-3x"></i></h1>
                                <br />
                                <p className="h4 text-uppercase text-bold">{this.props.title}</p>
                                <div className="pad-btm">
                                    {message.map((m, index) => <div key={`success_${index}_${m}`}>{m}</div>)}
                                </div>

                                {this.props.components !== undefined ? <Page robostackResolveData={this.props.components} /> : null}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button  aria-label="Okay Button" onClick={this.onClose.bind(this)} type="button" className="btn btn-primary" data-dismiss="modal">{this.props.okayButtonText}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(SuccessModal);